import axios from "axios";
import { useNavigate } from "react-router-dom";
import { config, isDevMode } from "./Constants";
import { useDispatch } from "react-redux";
import { resetResponseState } from "../features/responseSlice";
import { attachHttpRecorder } from "../New/utils/httpRecorder";

const IVSURL = config.ivs;
const RAW_IVS_BASIC = String.raw`>zU~MT{Ri\7}PT$de}1-Il8gZ:75b8(#U|YTQ-8{0~zo07=dOp,`;

const tokenivs = btoa(RAW_IVS_BASIC);

const useMerchantPortalIVSAxios = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const client = attachHttpRecorder(axios.create({
    baseURL: IVSURL,
    timeout: isDevMode ? 300000 : 15000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${tokenivs}`,
    },
  }), "merchant-portal-ivs");

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      //       if (status === 401) {
      //         sessionStorage.clear();
      //         dispatch(resetResponseState());
      //         navigate("/", { replace: true });
      //       }
      return Promise.reject(error);
    }
  );

  return client;
};

export default useMerchantPortalIVSAxios;
